<template>
  <div>
    <main-toolbar></main-toolbar>
    <v-layout row justify-center class="hidden-sm-and-down" v-if="!isLoading">
      <v-card class="surfAndScanborder"  style="min-width: 50%;">
        <v-card-text class="display-1 font-weight-bold abstandObenklein"
        >
          Was möchten Sie scannen?
        </v-card-text>

        <v-layout row wrap justify-space-around abstandcardunten>
          <v-flex d-flex xs12 sm12 md5 fluid>
            <v-card
              flat
              color="transparent"
              class="abstandObenk3 handpointer">
              <div @click="singlePage()">
                <center>
                  <v-img
                    max-width="150px"
                    width="150px"
                    :src="require('./../../assets/onepage_sas.png')"/>
                </center>
                <v-card-text class="title font-weight-bold abstandObenklein"
                >
                  EINE SEITE
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
          <v-flex d-flex xs12 sm1 md1 class="hidden-sm-and-down">
            <div class="borderdown"></div>
          </v-flex>
          <v-flex d-flex xs12 sm12 md5 fluid>
            <v-card
              flat
              color="transparent"
              class="abstandObenk3 handpointer">
              <div @click="multiPage()">
                <center>
                  <v-img
                    max-width="150px"
                    width="150px"
                    :src="require('./../../assets/MehrereSeiten_surfandscan.png')"/>
                </center>
                <v-card-text class="title font-weight-bold abstandObenklein"
                >
                  MEHRERE SEITEN
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- Ende Seite 1 -->
  </v-layout>
  </div>
</template>

<script>
import Vue from 'vue'
import MainToolbar from './../toolbar/MainToolbar'
export default {
  components: {MainToolbar},
  name: 'page01',
  data () {
    return {
    }
  },
  methods: {
    singlePage: function () {
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'duplex',
        value: false
      })
      this.$router.push('page2')
    },
    multiPage: function () {
      Vue.prototype.$eventHub.$emit('setConfiguration', {
        name: 'duplex',
        value: true
      })
      this.$router.push('page2')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Page01.vue